import React from "react";
import { NavLink } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

const Menu = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top shadow-sm">
      <div className="container">
        <NavLink className="navbar-brand" to="/">
          <img 
            src="/images/Logofucsia.png"
            alt="Logo" 
            width="100" 
            className="d-inline-block align-text-top"
          />
        </NavLink>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav">

            <li className="nav-item me-4">
              <NavLink 
                to="/"
                className="nav-link"
                style={({ isActive }) => ({
                  color: isActive ? '#b91667' : '#333', // Rosa cuando está activa
                  fontWeight: isActive ? 'bold' : 'normal'
                })}
              >
                <h5>Trabaja con nosotros</h5>
              </NavLink>
            </li>

            <li className="nav-item me-4">
              <NavLink 
                to="/ofertas"
                className="nav-link"
                style={({ isActive }) => ({
                  color: isActive ? '#b91667' : '#333',
                  fontWeight: isActive ? 'bold' : 'normal'
                })}
              >
                <h5>Ofertas</h5>
              </NavLink>
            </li>

            <li className="nav-item me-4">
              <NavLink 
                to="/login"
                className="nav-link"
                style={({ isActive }) => ({
                  color: isActive ? '#b91667' : '#333',
                  fontWeight: isActive ? 'bold' : 'normal'
                })}
              >
                <h5>Inicio de sesión</h5>
              </NavLink>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Menu;
